import {useState} from 'react';
import {Box, InputAdornment, Typography, Button, SxProps} from '@mui/material';
import TextField from '@jobseeker/lotus/elements/Input';
import Dialog from '@jobseeker/lotus/components/Dialog';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {Image} from '@jobseeker/lotus/components/Image';
import {SearchIcon} from '@jobseeker/lotus/icons';

interface MobileSelectDialogV3Props {
  open: boolean;
  onClose: () => void;
  title: string;
  options: {label: string; value: string | number}[];
  onChange: any;
  subtitle?: string;
  label?: string;
  className?: string;
}

const MobileSelectDialogV3: React.FC<MobileSelectDialogV3Props> = ({
  open,
  onClose,
  title,
  options,
  onChange,
  subtitle,
  label,
  className = '',
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      invertedTitle={false}
      variant={VersionVariants.VERSION_EIGHT}
      subtitle={subtitle}
      onDoneClick={() => {
        onChange(searchQuery);
        setSearchQuery('');
      }}
      className={className}
    >
      <Box>
        <TextField
          fullWidth
          placeholder={`${label}`}
          value={searchQuery}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Image src={SearchIcon} alt="search" width={16} height={16} />
              </InputAdornment>
            ),
          }}
          sx={{
            '.MuiInputBase-input': {
              border: 'unset !important',
              fontSize: '12px !important',
              paddingLeft: 0,
              py: '13px',
            },
            '.MuiInputBase-input::placeholder': {
              fontSize: '12px',
              fontWeight: 400,
              color: '#7E7E7E',
              opacity: 0.8,
            },
            mb: '8px',
          }}
          onChange={e => setSearchQuery(e.target.value)}
          // sx={{
          //   mb: 2,
          //   '& .MuiOutlinedInput-root': {
          //     borderRadius: '8px',
          //   },
          // }}
          onKeyDown={e => {
            if (e.key !== 'Escape') {
              // Prevents autoselecting item while typing (default Select behaviour)
              e.stopPropagation();
            }
          }}
          variant={VersionVariants.VERSION_TWO}
        />
        <Box sx={{maxHeight: '750px', overflowY: 'auto'}}>
          {filteredOptions.length > 0 ? (
            filteredOptions.slice(0, 100).map(option => (
              <Box
                key={option.value}
                onClick={() => {
                  onChange(option.value);
                  onClose();
                }}
                sx={{
                  padding: '10px 8px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  // '&:hover': {
                  //   backgroundColor: '#f5f5f5',
                  // },
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 400,
                  }}
                >
                  {option.label}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                color: '#7E7E7E',
                fontSize: '12px',
                fontWeight: 400,
                opacity: 1,
                mt: 1,
              }}
            >
              No results found
            </Typography>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default MobileSelectDialogV3;
